import Share from './report'
// import requireAuth from '../../require-auth'

export default Share



// WEBPACK FOOTER //
// ./src/components/pages/share/index.ts